import { Link } from 'react-router-dom';

function Layout({ children }) {

  const logout = () => {
    localStorage.removeItem('isLoggedIn');
    window.location.href = '/login';
  };

  return (
    <div style={{ display: 'flex' }}>

      {/* Sidebar */}
      <div style={{
        width: '260px',
        height: '100vh',
        background: '#343a40',
        color: 'white',
        padding: '20px',
        position: 'fixed'
      }}>
        <h3>Kalyan School</h3>
        <hr />
        <p><Link to="/" style={{ color: 'white' }}>Dashboard</Link></p>
        <p><Link to="/students" style={{ color: 'white' }}>Students</Link></p>
        <p><Link to="/parents" style={{ color: 'white' }}>Parents</Link></p>
        <p><Link to="/fees" style={{ color: 'white' }}>Fees</Link></p>
        <p><Link to="/reports" style={{ color: 'white' }}>Reports</Link></p>
        <p><Link to="/attendance" style={{ color: 'white' }}>Attendance</Link></p>
        <hr />
        <button className="btn btn-danger" onClick={logout}>Logout</button>
      </div>

      {/* Main Content */}
      <div style={{
        marginLeft: '260px',
        flex: 1,
        padding: '20px'
      }}>
        {children}
      </div>
    </div>
  );
}

export default Layout;